import Parse from "parse";

export const addDebitnote = async (data) => {
  return Parse.Cloud.run("addDebitNote", data);
};

export const getDebitNote = async (data) => {
  return Parse.Cloud.run("getDebitNotesBySchemeId", data);
};
